import React, { FC, memo } from 'react';
import { SelfIssuedReceiptsTable } from './SelfIssuedReceiptsTable';
import { TableFilterContextProvider } from 'features/TableFilter';

export const SelfIssuedReceiptsPage: FC = memo(() => {
  return (
    <TableFilterContextProvider>
      <SelfIssuedReceiptsTable />
    </TableFilterContextProvider>
  );
});
